export default __webpack_public_path__ + "static/media/dash.90611b21.svg";